import React from 'react';

let WelcomeMessage = () => {
    return (
        <div>
            <p id="kr-welcome-message">Witaj w nowej wersji kreatora orynnowania!</p>
            <p id="kr-choose-filters-message">Wybierz odpowiedni system rynnowy korzystając z powyższych filtrów.</p>
        </div>
    )
}

export default WelcomeMessage;